<div class="game-list-item">
	<div class="game-info">
		<h3>{{titleConvert(game.title)}} at {{game.venue}}</h3>
		<p>{{formatDate()}}</p>
		<p>Status: <span [ngClass]="statusClass">{{game.status?.toUpperCase()}}</span></p>
		<p *ngIf="game.hosts && game.hosts.length" class="no-m">
			<strong>Hosted By:</strong>
			<span *ngFor="let h of game.hosts; let i = index" class="md-ml">
				<span *ngIf="i > 0 && game.hosts.length > 2">,</span>
				<span *ngIf="i === game.hosts.length - 1 && game.hosts.length > 1"> and </span>
				<span>{{h.name}}</span>
			</span>
		</p>
	</div>
	<div *ngIf="!loading" class="vert-center">
		<a
			*ngIf="game.status !== 'live' && game.status !== 'scheduled'"
      routerLink="/recaps/{{game.gameid}}"
			>
			<button class="basic-btn-lgt-blue">Open Recap</button>
		</a>
		<a
			*ngIf="game.status !== 'scheduled' && game.status !== 'finalized' && game.status !== 'archived'"
			href="{{hostUri}}/game/{{game.gameid}}/live"
			target="_blank">
			<button class="basic-btn-red">Open Game</button>
		</a>
	</div>
	<div *ngIf="loading" class="vert-center">
		<span class="center-text">Confirming...</span>
	</div>
</div>
